import React, { useState } from "react"
import _, { flowRight as compose } from "lodash"
import {
  Card,
  CardBody,
  Button,
  Input,
  Form,
  FormGroup,
  Label,
  CardHeader,
  CardFooter,
  Alert
} from "reactstrap"
import Select from "react-select"
import { useMutation, useQuery } from "@apollo/react-hooks"
import { withRouter } from "react-router"
import { BackButton } from "components/utility"
import { BarLoader } from "components/spinner"
import { CREATE_USER, UPDATE_USER, GET_COMPANIES } from "../gql"
import roleOptions from "../roleOptions"
import userAreaOptions from "../userAreaOptions"

const UserForm = (props) => {
  const [localData, setLocalData] = useState(
    props.data || {
      name: "",
      email: "",
      company: "",
      role: "",
      title: "",
      dept: "",
      isEnable: true
    }
  )
  const [
    updateUser,
    { loading: updateLoading, error: updateError }
  ] = useMutation(UPDATE_USER)
  const [
    createUser,
    { loading: createLoading, error: createError }
  ] = useMutation(CREATE_USER)
  const { data: companyData } = useQuery(GET_COMPANIES, {
    fetchPolicy: "cache-and-network"
  })
  console.log("companyData", companyData)
  const [selectedCompany, setSelectedCompany] = useState(
    (localData?.company && {
      value: localData?.company?.id,
      label: localData?.company?.name
    }) ||
      undefined
  )

  const [selectedRole, setSelectedRole] = useState(
    (localData?.role &&
      _.find(
        roleOptions(selectedCompany),
        (option) => option.value === localData.role
      )) ||
      undefined
  )
  const [selectedUserAreas, SetSelectedUserAreas] = useState(
    (localData?.areas &&
      _.filter(userAreaOptions, (option) =>
        localData.areas.includes(option.value)
      )) ||
      []
  )

  const checkRequire = () => {
    return (
      localData.name === "" ||
      localData.email === "" ||
      selectedCompany === undefined ||
      selectedRole === undefined ||
      (selectedCompany?.label === "GETECH" && selectedUserAreas.length === 0)
    )
  }

  const onFieldChange = (key, value) => {
    setLocalData({
      ...localData,
      [key]: value
    })
  }

  const variableFromData = () => {
    return {
      ...(localData.id && { id: localData.id }),
      input: {
        name: localData.name,
        email: localData.email,
        ...(localData.newPassword &&
          localData.newPassord !== "" && {
            newPassword: localData.newPassword
          }),
        company: selectedCompany.value,
        role: selectedRole.value,
        areas: selectedUserAreas
          ? selectedUserAreas.map((area) => area.value)
          : undefined,
        dept: localData.dept,
        title: localData.title,
        isEnable: localData.isEnable
      }
    }
  }

  const onSaveButtonClick = async () => {
    if (localData.id) {
      await updateUser({
        variables: variableFromData()
      })
    } else {
      await createUser({
        variables: variableFromData()
      })
    }

    props.history.goBack()
  }

  return (
    <div className="">
      <Card>
        <CardHeader>
          <BackButton left />
        </CardHeader>

        <CardBody>
          <Form
            style={{
              marginLeft: "10px",
              marginRight: "10px"
            }}
          >
            <FormGroup row>
              <Label for="name">名稱 *</Label>
              <Input
                type="text"
                name="name"
                id="name"
                placeholder="名稱"
                value={localData.name}
                onChange={(e) => onFieldChange("name", e.target.value)}
              />
            </FormGroup>
            <FormGroup row>
              <Label for="email">電郵 *</Label>
              <Input
                type="text"
                name="email"
                id="email"
                placeholder="電郵"
                value={localData.email}
                onChange={(e) => onFieldChange("email", e.target.value)}
              />
            </FormGroup>
            <FormGroup row>
              <Label>選擇公司 *</Label>
              <div style={{ width: "100%" }}>
                <Select
                  placeholder="選擇公司"
                  value={selectedCompany}
                  options={companyData?.companies?.data?.map((item) => {
                    return {
                      value: item.id,
                      label: `${item.name}`
                    }
                  })}
                  onChange={(option) => {
                    setSelectedRole(roleOptions(option)[0])
                    setSelectedCompany(option)
                  }}
                />
              </div>
            </FormGroup>
            <FormGroup row>
              <Label>選擇角色 *</Label>
              <div style={{ width: "100%" }}>
                <Select
                  placeholder="選擇角色"
                  value={selectedRole}
                  options={selectedCompany && roleOptions(selectedCompany)}
                  onChange={(option) => {
                    setSelectedRole(option)
                  }}
                />
              </div>
            </FormGroup>
            {selectedCompany &&
              selectedCompany.label &&
              selectedCompany.label === "GETECH" && (
                <FormGroup row>
                  <Label for="newPassword">區域 *</Label>
                  <div style={{ width: "100%" }}>
                    <Select
                      isMulti={true}
                      value={selectedUserAreas}
                      options={userAreaOptions}
                      onChange={(option) => SetSelectedUserAreas(option)}
                    />
                  </div>
                </FormGroup>
              )}
            <FormGroup row>
              <Label for="title">職稱</Label>
              <Input
                type="text"
                name="title"
                id="title"
                placeholder="職稱"
                value={localData.title || ""}
                onChange={(e) => onFieldChange("title", e.target.value)}
              />
            </FormGroup>
            <FormGroup row>
              <Label for="dept">部門</Label>
              <Input
                type="text"
                name="dept"
                id="dept"
                placeholder="部門"
                value={localData.dept || ""}
                onChange={(e) => onFieldChange("dept", e.target.value)}
              />
            </FormGroup>
            {localData.id && (
              <>
                <FormGroup row>
                  <Label for="newPassword">新密碼</Label>
                  <Input
                    type="password"
                    name="newPassword"
                    id="newPassword"
                    placeholder="新密碼"
                    value={localData.newPassword}
                    onChange={(e) =>
                      onFieldChange("newPassword", e.target.value)
                    }
                  />
                </FormGroup>
              </>
            )}
            <FormGroup className="pl-1" check>
              <Label check>
                <Input
                  type="checkbox"
                  checked={localData.isEnable}
                  onChange={(e) => {
                    onFieldChange("isEnable", e.target.checked)
                  }}
                />{" "}
                是否啟用
              </Label>
            </FormGroup>
          </Form>
        </CardBody>
        <CardFooter>
          <Button
            color="primary"
            disabled={checkRequire()}
            onClick={onSaveButtonClick}
          >
            送出
          </Button>
          {!localData.id && (
            <Alert color="warning" className="mt-3">
              [提示] 新使用者的預設密碼為所屬公司統編。
            </Alert>
          )}
        </CardFooter>

        <BarLoader loading={updateLoading || createLoading} />
      </Card>
      {(createError || updateError) && (
        <Alert color="danger">
          錯誤訊息：{`${createError || updateError}`}
        </Alert>
      )}
    </div>
  )
}

export default compose(withRouter)(UserForm)
